/* eslint-disable no-unused-vars */
/* eslint-disable semi */import firebase from 'firebase/compat/app';
import { resolve } from 'config';
import Base from './base';

export default class Config extends Base {
  constructor(firebase, applicationId) {
    super(firebase, applicationId, 'config');
  }
  list = () => {
    return new Promise((resolve, reject) => {
      const map = {};
      this.collection.get().then(
        querySnapshot => {
          querySnapshot.docs.map(doc => {
            map[doc.id] = doc.data();
          });
          resolve({ code: 0, body: map });
        },
        error => {
          resolve({ code: -1, body: error });
        }
      );
    });
  };
}
